import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Landing from './Landing';

/**
 * LandingRedirect component
 * Shows Landing page for guests, redirects authenticated users to /notes
 */
function LandingRedirect() {
  const { isAuthenticated, isLoading } = useAuth();

  // Show loading while checking auth status
  if (isLoading) {
    return (
      <div style={styles.container}>
        <div style={styles.loader}>Loading...</div>
      </div>
    );
  }

  // If user is authenticated, redirect to notes app
  if (isAuthenticated) {
    return <Navigate to="/notes" replace />;
  }

  // Otherwise, show landing page
  return <Landing />;
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f3f9fc',
  },
  loader: {
    color: '#102a43',
    fontSize: '1.5rem',
    fontWeight: '500',
  },
};

export default LandingRedirect;
